import React, {PureComponent} from 'react';
import Input from './Input';

export default class InputRegular extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            errorActive: false,
            value: '',
            passwordShow: true,
            min: this.props.min
        };
    }

    componentDidMount() {
        // if (this.props.required) {
        //     this.props.updateErrorsList(true, this.props.id);
        // }
        if (this.props.fieldsCheckActive && this.props.required) {
            let type = this.props.type;
            let value = this.props.value;
            this.setState({value})
            if (type === 'text') {
                let check = this.charCountIsValid(value ? value.length : 0, 1)
                if (value !== this.state.value) {
                    if (check && value) {
                        this.setState({errorActive: false})
                    } else {
                        this.setState({errorActive: true})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'email') {
                let check = this.emailIsValid(value)
                if (value !== this.state.value) {
                    if (check && value) {
                        this.setState({errorActive: false})
                    } else {
                        this.setState({errorActive: true})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'alphanumeric-id') {
                let check = this.alphanumericId(value)
                if (value !== this.state.value) {
                    if (check && value) {
                        this.setState({errorActive: false})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({errorActive: true})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'project-name') {
                let check = this.projectName(value)
                if (value !== this.state.value) {
                    if (check && value) {
                        this.setState({errorActive: false})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({errorActive: true})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'password') {
                let check = this.passwordValid(value)
                if (value !== this.state.value) {
                    if (check && value) {
                        this.setState({errorActive: false})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({errorActive: true})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'value-below') {
                let check = this.checkIfValueBelow(this.props.valueBelow)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({errorActive: true, value})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'url') {
                let check = this.urlIsValid(this.props.value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({errorActive: true, value})
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            }
        }
    }

    componentDidUpdate = () => {
        if (this.state.value !== this.props.value && this.props.type === 'text') {
            //let type = this.props.type;

            let value = this.props.value;
            let check = this.charCountIsValid(value ? value.length : 0, 1)

            //console.log('cdu - value has changed')
            if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                if (check && value.length !== 0) {
                    this.setState({errorActive: false, value})

                    if (this.props.updateErrorsList) {
                        this.props.updateErrorsList(false, this.props.id)
                    }

                } else {
                    this.setState({errorActive: true, value})
                    if (this.props.updateErrorsList) {
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            }
        }
        if (this.props.fieldsCheckActive && this.props.required) {
            let type = this.props.type;
            let value = this.props.value;
            // console.log('inputRegular data: ', type, value)
            if (type === 'text') {
                //console.log('input is text')
                let check = this.charCountIsValid(value ? value.length : 0, 1)

                // console.log('cdu - check: ', check)
                // console.log('cdu - value: ', value)
                // console.log('cdu - value.length: ', value.length)

                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value.length !== 0) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'email') {
                let check = this.emailIsValid(value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'number') {
                let check = this.charCountIsValid(value ? value.length : 0, 1)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'value-below') {
                let check = this.checkIfValueBelow(this.props.valueBelow)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'alphanumeric-id') {
                let check = this.alphanumericId(value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'project-name') {
                let check = this.projectName(value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'password') {
                let check = this.passwordValid(value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'url') {
                let check = this.urlIsValid(this.props.value)
                if ((value !== this.state.value) || (!value && !this.state.errorActive)) {
                    if (check && value) {
                        this.setState({errorActive: false, value})
                        if (this.props.updateErrorsList) {
                            this.props.updateErrorsList(false, this.props.id)
                        }
                    } else {
                        this.setState({
                            errorActive: true,
                            value
                        })
                        this.props.updateErrorsList(true, this.props.id)
                    }
                }
            } else if (type === 'always-error') {
                if (this.props.fieldsCheckActive) {
                    this.setState({
                        errorActive: true,
                        value
                    })
                } else {
                    this.setState({
                        errorActive: false,
                        value
                    })
                }
            }
        } else if (this.props.fieldsCheckActive && this.props.required && !this.props.value) {
            this.setState({errorActive: true})
            this.props.updateErrorsList(true, this.props.id)
        }
        // }else if (this.props.fieldsCheckActive && this.props.required && !this.props.value) {
        //     this.setState({errorActive: true, value: this.props.value})
        //     this.props.updateErrorsList(true, this.props.id)
        // }
        if ((this.props.type === 'always-error') && !this.props.fieldsCheckActive) {
            this.setState({errorActive: false, value: this.props.value})
        }
        if (this.state.min !== this.props.min) {
            this.setState({
                min: this.props.min
            })
        }
    }


    emailIsValid = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    urlIsValid = (url) => {
        return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(url);
    }

    charCountIsValid = (count, limit) => {
        //console.log('limit: ', limit)
        //console.log('count: ', count)

        return count >= limit;
    }

    checkIfValueBelow = (number) => {
        let valueBelow = parseInt(number);
        // console.log('checkIfValueBelow: ', valueBelow, this.props.value, valueBelow <= this.props.value)
        return valueBelow <= this.props.value;
    }

    checkForSpecChars = (text) => {
        let check = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(text)
        // console.log('check for spec char: ', check)
        return !check
    }

    checkForRestrictedWords = (text) => {
        let arrayOfRestrictedWords = ['CIA', 'FBI', 'BIA', 'MUP', 'GOV', 'APR', 'Interpol', 'MTS', 'Telekom', 'Telecom',
            'A1', 'Telenor', 'VIP', 'MI5', 'MI6', 'WHO', 'COVID', 'COVID19', 'IRS', 'Amazon', 'AWS', 'Google', 'Gmail',
            'Yahoo', 'iCloud', 'Apple', 'Samsung', 'Bank', 'WellsFargo', 'Chase', 'Fedex', 'DHL', 'Bitcoin', 'BTC', 'XRP',
            'Ripple', 'CEX', 'CEXIO', 'WesternUnion', 'EE', 'Three', 'Vodafone', 'TMobile', 'T-Mobile', 'GDPR', 'AT&T',
            'GPS', 'GSM', 'EDGE', 'WiFi', 'PayPal', 'Amex', 'Discover', 'O2', 'Verizon', 'Police', 'Alarm', 'Payoneer',
            'VISA', 'MasterCard', 'Intesa', 'UniCredit', 'UniCreditBank', 'Twilio', 'SMS', 'Tyntec', 'Facebook',
            'Instagram', 'TikTok', 'Twitter', 'MacBook', 'Tesla', 'Vaccine', 'Hermes', 'Post', 'Mail', 'iPhone',
            'Huawei', 'Xiaomi', 'Stripe', 'JPMorgan', 'Citigroup', 'MorganStanley', 'Bancorp', 'USBank', 'Truist',
            'GoldmanSachs', 'TDGroup', 'Holding', 'EU', 'EUR', 'Euro', 'Dollar', 'Money']

        let checkResult = false;

        let textToArray = text.split(' ');

        textToArray.map(text => arrayOfRestrictedWords.map(word => word.toLowerCase() === text.toLowerCase() ? checkResult = true : ''))

        // arrayOfRestrictedWords.map(word => text.toLowerCase().includes(word.toLowerCase()) ? checkResult = true : '');

        // console.log('checkForRestrictedWords: ', text, textToArray, checkResult)

        return !checkResult
    }

    alphanumericId = (id) => {
        // console.log('Provera: ', id, id.length < 12, /[a-zA-Z]/.test(id), this.checkForSpecChars(id))
        if (id && id.length < 12 && /[a-zA-Z]/.test(id) && this.checkForSpecChars(id) && this.checkForRestrictedWords(id)) {
            return true
        } else {
            return false
        }
    }

    projectName = (id) => {
        // console.log('Provera: ', id, id.length < 12, /[a-zA-Z]/.test(id), this.checkForSpecChars(id))
        if (id && /[a-zA-Z]/.test(id) && this.checkForSpecChars(id)) {
            return true
        } else {
            return false
        }
    }

    passwordValid = (password) => {
        if (password && password.length > 7 && /[a-zA-Z]/.test(password) && (/(?=.*\d)/.test(password) || !this.checkForSpecChars(password))) {
            return true
        } else {
            return false
        }
    }

    togglePasswordShow = async () => {
        //console.log('password toggled')
        let passwordShow = await this.state.passwordShow
        this.setState(
            {
                passwordShow:
                    !passwordShow
            })
    }
    defaultBlur = () => {

    }

    render() {
        let label1 = this.props.label1;
        let label2 = this.props.label2;
        let value = this.props.value;
        let errorMessage = this.props.errorMessage;
        let required = this.props.required;
        let type = this.props.type;
        let disabled = this.props.disabled;
        let passwordShow = this.state.passwordShow;

        return (
            <div className={this.props.disabled ? 'input-disabled' : ''}>
                <div className="input-labels-container">
                    <label className={disabled ? 'disabled-label' : ''}>
                        {label1}
                    </label>
                    <label className='disabled-label'>
                        {label2 ? label2 : !required && type !== 'password' ? 'Optional' : ''}
                    </label>
                </div>
                <div
                    className={this.state.errorActive ? "input-error-container input-error-container-active" : "input-error-container"}
                    style={{marginBottom: this.props.spaceBellowInput && this.state.errorActive ? this.props.spaceBellowInput : 0}}>
                    {this.props.textArea ?
                        <textarea
                            className={
                                this.props.oneLineTextArea ?
                                    this.state.errorActive && this.props.required ? 'small-textarea textarea-error register-password' :
                                        this.props.disabled ? 'small-textarea textarea-disabled register-password' : 'small-textarea textarea-regular register-password'
                                    :
                                    this.state.errorActive && this.props.required ? 'textarea-error register-password' : this.props.disabled ? 'textarea-disabled register-password' : 'textarea-regular register-password'
                            }
                            placeholder={this.props.placeholder}
                            value={value}
                            required={required}
                            disabled={disabled || false}
                            onChange={({currentTarget: input}) => this.props.onChange(input ? input.value : '')}
                            onBlur={this.props.onBlur ? this.props.onBlur : this.defaultBlur}
                        />
                        :
                        <Input
                            type={type === 'password' ? passwordShow ? 'password' : 'text' : this.props.type ? this.props.type : ''}
                            className={this.state.errorActive && this.props.required ? 'input-error register-password' : this.props.disabled ? 'input-disabled register-password' : 'input-regular register-password'}
                            placeholder={this.props.placeholder}
                            value={value}
                            required={required}
                            disabled={disabled || false}
                            onChange={({currentTarget: input}) => this.props.onChange(input ? input.value : '')}
                            onBlur={this.props.onBlur ? this.props.onBlur : this.defaultBlur}
                            min={this.state.min ? this.state.min : ''}
                            step={this.props.step ? this.props.step : ''}
                        />
                    }

                    {
                        (type === 'password') && passwordShow === true ?
                            <i className='fa fa-eye password-eye-opacity-regular-input'
                               onClick={this.togglePasswordShow}></i> :
                            (type === 'password') ?
                                <i className='fa fa-eye password-eye-regular-input'
                                   onClick={this.togglePasswordShow}></i> :
                                null
                    }
                    {<div className="alert alert-danger"
                          style={this.state.errorActive ? {padding: 0} : this.props.disableErrorHeight ? {
                              height: 0,
                              padding: 0
                          } : {padding: 0}}>
                        {this.state.errorActive && this.props.required ? errorMessage : ''}
                    </div>}
                </div>
                {/*{this.state.errorActive ? console.log(required, errorMessage, this.state.errorActive) : ''}*/}
            </div>
        );
    }
};